import React, { useState } from 'react';
import './App.css';

// Import components
import Header from './components/Header';
import Hero from './components/Hero';
import WhySection from './components/WhySection';
import FeaturesSection from './components/FeaturesSection';
import ExampleSection from './components/ExamplesSection';
import Footer from './components/Footer';

import DemoSection from './components/DemoSection';
import HowItWorksSection from './components/HowItWorksSection';

import GetStartedModal from './components/GetStartedModal';

import PrivacyPolicy from './components/modalComponents/PrivacyPolicy';
import Documentation from './components/modalComponents/Documentation';
import Support from './components/modalComponents/Support';
import TermsOfService from './components/modalComponents/TermsOfService';

import AboutUs from './components/modalComponents/AboutUs';
import Careers from './components/modalComponents/Careers';
import Blog from './components/modalComponents/Blog';
import Contact from './components/modalComponents/Contact';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState(false);
  const [isDocumentationOpen, setIsDocumentationOpen] = useState(false);
  const [isSupportOpen, setIsSupportOpen] = useState(false);
  const [isTermsOfServiceOpen, setIsTermsOfServiceOpen] = useState(false);

  const [isAboutUsOpen, setIsAboutUsOpen] = useState(false);
  const [isCareersOpen, setIsCareersOpen] = useState(false);
  const [isBlogOpen, setIsBlogOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const openGetStarted = () => {
    handleOpenModal();
  };

  const handleOpenPrivacyPolicy = () => {
    setIsPrivacyPolicyOpen(true);
  };

  const handleClosePrivacyPolicy = () => {
    setIsPrivacyPolicyOpen(false);
  };

  const handleOpenDocumentation = () => {
    setIsDocumentationOpen(true);
  };
  
  const handleCloseDocumentation = () => {
    setIsDocumentationOpen(false);
  };
  
  // Support modal handlers
  const handleOpenSupport = () => {
    setIsSupportOpen(true);
  };
  
  const handleCloseSupport = () => {
    setIsSupportOpen(false);
  };
  
  // Terms of Service modal handlers
  const handleOpenTermsOfService = () => {
    setIsTermsOfServiceOpen(true);
  };
  
  const handleCloseTermsOfService = () => {
    setIsTermsOfServiceOpen(false);
  };

  // About Us modal handlers
const handleOpenAboutUs = () => {
  setIsAboutUsOpen(true);
};

const handleCloseAboutUs = () => {
  setIsAboutUsOpen(false);
};

// Careers modal handlers
const handleOpenCareers = () => {
  setIsCareersOpen(true);
};

const handleCloseCareers = () => {
  setIsCareersOpen(false);
};

// Blog modal handlers
const handleOpenBlog = () => {
  setIsBlogOpen(true);
};

const handleCloseBlog = () => {
  setIsBlogOpen(false);
};

// Contact modal handlers
const handleOpenContact = () => {
  setIsContactOpen(true);
};

const handleCloseContact = () => {
  setIsContactOpen(false);
};

  return (
    <div className="App min-h-screen">
      <Header onGetStarted={openGetStarted} />
      
      <main>
        <Hero onGetStarted={openGetStarted} />
        <WhySection />
        <ExampleSection />
        <FeaturesSection />
      </main>

      <div className="demo-container">
        <HowItWorksSection />
        <DemoSection />
        
      </div>

      {/* <Footer 
        onOpenPrivacyPolicy={handleOpenPrivacyPolicy}
        onOpenDocumentation={handleOpenDocumentation}
        onOpenSupport={handleOpenSupport}
        onOpenTermsOfService={handleOpenTermsOfService}
        onOpenAboutUs={handleOpenAboutUs}
        onOpenCareers={handleOpenCareers}
        onOpenBlog={handleOpenBlog}
        onOpenContact={handleOpenContact}
      /> */}

      <GetStartedModal 
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />

      <PrivacyPolicy 
        open={isPrivacyPolicyOpen}
        onClose={handleClosePrivacyPolicy}
      />

      {/* New modal components */}
      <Documentation
        open={isDocumentationOpen}
        onClose={handleCloseDocumentation}
      />

      <Support
        open={isSupportOpen}
        onClose={handleCloseSupport}
      />

      <TermsOfService
        open={isTermsOfServiceOpen}
        onClose={handleCloseTermsOfService}
      />

      <AboutUs
        open={isAboutUsOpen}
        onClose={handleCloseAboutUs}
      />

      <Careers
        open={isCareersOpen}
        onClose={handleCloseCareers}
      />

      <Blog
        open={isBlogOpen}
        onClose={handleCloseBlog}
      />

      <Contact
        open={isContactOpen}
        onClose={handleCloseContact}
      />
    </div>
  );
}

export default App;